<template>
  <v-container id="manage" class="py-0">
    <v-card class="display-flex pa-4 pb-12" style="min-height: 70vh">
      <div> <!-- sticky not working with flex element -->
        <div style="position: sticky; top: 70px;">
          <v-tabs v-model="manageTabIndex" vertical slider-color="primary" background-color="white"
                  active-class="primary lighten-1 white--text">
            <v-tab class="manage-tab-pill" href="#users">
              <v-icon size="20" class="mr-2" style="color: inherit; transition: none;">fas fa-users</v-icon>
              <span class="hidden-sm-and-down" style="font-size: 16px">{{ $t('MANAGE.COMPANY_USERS') }}</span>
            </v-tab>
            <v-tab class="manage-tab-pill" href="#projects">
              <v-icon size="20" class="mr-2" style="color: inherit; transition: none; width: 24px">fas fa-folder-open</v-icon>
              <span class="hidden-sm-and-down" style="font-size: 16px">{{ $t('MANAGE.PROJECTS') }}</span>
            </v-tab>
            <v-tab class="manage-tab-pill" href="#configuration">
              <v-icon size="20" class="mr-2" style="color: inherit; transition: none; width: 24px">fas fa-cog</v-icon>
              <span class="hidden-sm-and-down" style="font-size: 16px">{{ $t('MANAGE.CONFIGURATION') }}</span>
            </v-tab>
          </v-tabs>
        </div>
      </div>

      <v-divider vertical class="mx-4 primary" style="border: 1px solid;"></v-divider>

      <v-tabs-items v-model="manageTabIndex" class="flex-grow-1" style="overflow: unset"> <!-- overflow: unset needed for sticky tabbars -->
        <!-- TAB USERS -->
        <v-tab-item :transition="false" :reverse-transition="false" value="users" eager>
          <manage-users></manage-users>
        </v-tab-item>

        <!-- TAB PROJECTS-->
        <v-tab-item :transition="false" :reverse-transition="false" value="projects" eager>
          <manage-projects></manage-projects>
        </v-tab-item>

        <!-- TAB CONFIGURATION -->
        <v-tab-item :transition="false" :reverse-transition="false" value="configuration">
          <manage-config></manage-config>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<style>
  .manage-tab-pill {
    justify-content: flex-start;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
    border-radius: 4px 12px 12px 4px;
    padding: 0 12px;
    min-width: 0;
  }
</style>

<script>
  import { mapState } from 'vuex';
  import ManageUsers from './ManageUsers/ManageUsers';
  import ManageProjects from './ManageProjects/ManageProjects';
  import ManageConfig from './ManageConfig/ManageConfig';

  export default {
    components: {
      ManageUsers,
      ManageProjects,
      ManageConfig,
    },
    computed: {
      manageTabIndex: {
        get() {
          return this.$store.state.manage.manageTabIndex;
        },
        set(newVal) {
          this.$store.state.manage.manageTabIndex = newVal;
        },
      },
      ...mapState('manage', ['dataLoaded', 'projects', 'openedProjects', 'openedUsers']),
    },
    watch: {
      $route() {
        this.selectTab();
      },
    },
    created() {
      this.selectTab();
      this.$store.dispatch('manage/loadCompany');
      this.$store.dispatch('manage/loadProjects');
    },
    beforeDestroy() {
      this.$store.commit('eventbus/remove'); // remove all events listeners
      this.$store.commit('manage/reset');
    },
    methods: {
      selectTab() {
        if (this.$route.query.tab == 'users' || this.$route.query.tab == 'projects') {
          this.manageTabIndex = this.$route.query.tab;
          this.$router.replace({ query: {} });
          $(window).scrollTop(0);
        }
        if (this.$route.query.open) {
          setTimeout(() => {
            this.$store.dispatch('manage/openProjectFromId', this.$route.query.open);
            this.$router.replace({ query: {} });
            $(window).scrollTop(0);
          }, 300);
        }
      },
    },
  };
</script>
